// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SmallDashOutlinedSvg from "@ant-design/icons-svg/es/asn/SmallDashOutlined";
import AntdIcon from '../components/AntdIcon';

var SmallDashOutlined = function SmallDashOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SmallDashOutlinedSvg
  }));
};

SmallDashOutlined.displayName = 'SmallDashOutlined';
export default React.forwardRef(SmallDashOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/SmallDashOutlined.js
// module id = 1835
// module chunks = 0